import { SectionTypeEnum } from '@nucleus/types/web';
import { SectionDefaultBuilder } from '../SectionDefaultBuilder';

export const SermonActionsDefaults = new SectionDefaultBuilder<SectionTypeEnum.SermonActions>()
  .setStatic(() => {
    throw new Error('SermonActions sections are generated and should not use defaults');
  })
  .build();

export const SermonMediaDefaults = new SectionDefaultBuilder<SectionTypeEnum.SermonMedia>()
  .setStatic(() => {
    throw new Error('SermonMedia sections are generated and should not use defaults');
  })
  .build();

export const SermonSearchRequestDefaults = new SectionDefaultBuilder<SectionTypeEnum.SermonSearchRequest>()
  .setStatic(() => {
    throw new Error('SermonSearchRequest sections are generated and should not use defaults');
  })
  .build();

export const SermonSearchResultsDefaults = new SectionDefaultBuilder<SectionTypeEnum.SermonSearchResults>()
  .setStatic(() => {
    throw new Error('SermonSearchResults sections are generated and should not use defaults');
  })
  .build();

export const PostContentDefaults = new SectionDefaultBuilder<SectionTypeEnum.PostContent>()
  .setStatic(() => {
    throw new Error('PostContent sections are generated and should not use defaults');
  })
  .build();

export const PostHeaderDefaults = new SectionDefaultBuilder<SectionTypeEnum.PostHeader>()
  .setStatic(() => {
    throw new Error('PostHeader sections are generated and should not use defaults');
  })
  .build();

export const PostSearchRequestDefaults = new SectionDefaultBuilder<SectionTypeEnum.PostSearchRequest>()
  .setStatic(() => {
    throw new Error('PostSearchRequest sections are generated and should not use defaults');
  })
  .build();

export const PostSearchResultsDefaults = new SectionDefaultBuilder<SectionTypeEnum.PostSearchResults>()
  .setStatic(() => {
    throw new Error('PostSearchResults sections are generated and should not use defaults');
  })
  .build();
